import React, {Component} from "react";
import config from 'react-global-configuration';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import Stepper from 'react-stepper-horizontal';
import axios from "axios";
import $ from 'jquery';
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;


class BrandEMIAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emiMenus:[],
            stepsBrand: [{
                    title: '',

                  }, {
                    title: '',

                  }, {
                    title: '',
                    }
                ],
            stepsMerchant: [{
                title: '',

                }
            ],
            currentStepBrand: 0,
            currentStepMerch: 0,
            merchproduct: 0,
            brandproduct: 0,
            brandscheme: 0,
            brandpromotion: 0

        };

    }
    componentDidMount() {
        this.checkAdmin();
        this.getPartyID();
    }

    checkAdmin(){
        const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            if (decoded.userGroup == 1 || decoded.userGroup == '1'){
                this.props.history.push('/admin/admin-promotion-master');
            }
    }

    getPartyID(){
        this.setState({
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                //console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            this.getBrandUploadedData();
            this.getBrandUploadedDataScheme();
            this._refreshCampaign();
            this.getMerchantUploadedData();
        });
    }

    getBrandUploadedData(){
        this.setState({
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_brand_data', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            //console.log(response);
            if (response.data.length > 0){
                this.setState({
                    brandproduct: 1
                })
            }
                this.setState({
                loading: true
                });
            // response.data.map((value, index) => {
            //     let status = false;
            //     if(value.active_status===1) { status = true;}
            //     this.setState({
            //         activer: {...this.state.activer, [index]:status }
            //     });
            // });
            this.setState({
                brand_file_uploaded: response.data,
                loading: false
            });

        });
        return null;
    }

    getBrandUploadedDataScheme(){
        this.setState({
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_schemes_master_data', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            //console.log(response);
            if (response.data.length > 0){
                this.setState({
                    brandscheme: 1
                })
            }
                this.setState({
                loading: true
                });
            // response.data.map((value, index) => {
            //     let status = false;
            //     if(value.active===1) { status = true;}
            //     this.setState({
            //         activer: {...this.state.activer, [index]:status }
            //     });
            // });
            this.setState({
                brand_file_uploaded: response.data,
                loading: false
            });

        });
        return null;
    }

    _refreshCampaign() {
        this.setState({
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_campaign_brand',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
            }).then(response => {
            //console.log(response);
            if (response.data.length > 0){
                this.setState({
                    brandpromotion: 1
                })
            }
            this.setState({
                campaign_response: response.data
            });

            this.setState({
                loading: false
            })

        });
    }

    getMerchantUploadedData(){
        this.setState({
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_brand_data', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            //console.log(response);
            if (response.data.length > 0){
                this.setState({
                    merchproduct: 1
                })
            }
            // response.data.map((value, index) => {
            //     let status = false;
            //     if(value.active_status===1) { status = true;}
            //     this.setState({
            //         activer: {...this.state.activer, [index]:status }
            //     });
            // });
                this.setState({
                brand_file_uploaded: response.data,
                loading: false
            });

        });
        return null;
    }


    render() {

        // let notificationText='';
        // let countUnseen = 0;
        // if(Array.isArray(this.state.user_notifications) && this.state.user_notifications.length) {
        //     //if(this.state.user_notifications.length
        //     notificationText = this.state.user_notifications.map((val, i) => {
        //         if (val.status == 'not viewed') {
        //             countUnseen++;
        //         }
        //         return (
        //             <MenuItem eventKey={2.1} key={i + 1} componentClass={Link} href={"/admin/notifications/"+ val.notification_id } to={"/admin/notifications/"+ val.notification_id }>
        //                 <p>{val.message} </p>
        //                 <p><span className="pe-7s-clock bell-notification"></span><Moment
        //                     format='MMMM Do YYYY, h:mm:ss a'>{val.created_at}</Moment></p>
        //             </MenuItem>
        //         );
        //     });
        // }
        // else{
        //     notificationText =
        //          (
        //             <MenuItem eventKey={2.1}>
        //                 <p>&nbsp;</p>
        //                 <p>There is no notification. </p>
        //             </MenuItem>
        //         );

        // }
        // const notification = (
        //     <div>
        //         <i className="fa fa-bell"></i>
        //         <b className="caret" />
        //         {countUnseen>0?
        //         <span className="notification">{countUnseen}</span>
        //             : null }
        //         <p className="hidden-lg hidden-md">Notification</p>
        //     </div>
        // );

        let active_stepper = () => {
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            if (decoded.userGroup == '7' || decoded.userGroup == 7){
                if(this.state.brandpromotion == 1){
                    return 3;
                }
                else if(this.state.brandscheme == 1){
                    return 2;
                }
                else if(this.state.brandproduct == 1){
                    return 1;
                }
                else{
                    return 0;
                }

            }
            else{
                if(this.state.merchproduct == 1){
                    return 1;
                }
                else{
                    return 0;
                }
            }
        }
        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem  key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });
        let stepper_data = () => {
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            if (decoded.userGroup == '7' || decoded.userGroup == 7){
                return(
                    <div className="row">
                        <Stepper activeColor="#45379B" completeColor="#00F33D" defaultBarColor="#C0C0C0" completeBarColor="#C0C0C0" steps={ this.state.stepsBrand } activeStep={ active_stepper()} />
                    </div>
                )
            }
            else{
                return(
                    <div className="row">
                        <Stepper activeColor="#45379B" completeColor="#00F33D" defaultBarColor="#C0C0C0" completeBarColor="#C0C0C0" steps={ this.state.stepsMerchant } activeStep={ active_stepper() } />
                    </div>
                )
            }
        }

        let header_data = () => {
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            if (decoded.userGroup == 1 || decoded.userGroup == '1'){
                return(
                    <div className="header">

                    </div>
                )
            }
            else{
                return(
                    <div className="header">
                        <h5 className="title">
                            <b>GET STARTED</b>
                        </h5>
                    </div>
                )
            }
        }

        let show_data = () => {
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            if (decoded.userGroup == 7 || decoded.userGroup == '7'){
                return(
                    <div className="row">
                        <div className="col-md-4">
                            <div className="row">
                            <h5 className="brandemiheader">Add products</h5>
                            </div>
                            <div className="row brandemitext">
                                Add the details of the products<br/>in the predefined format and<br/>upload it in the portal.
                            </div>
                        </div>
                        <div className="col-md-4 ">
                            <div className="row">
                                <h5 className="brandemiheader">Create bank schemes</h5>
                            </div>
                            <div className="row brandemitext">
                                Create bank schemes<br/> by choosing available options<br/> and name it as you want.
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row ">
                            <h5 className="brandemiheader">Create promotions</h5>
                            </div>
                            <div className="row brandemitext">
                                Build Promotion by providing details <br/>regarding how you would like <br/>the promotion to function.
                            </div>
                        </div>
                    </div>
                )
            }
            else if(decoded.userGroup == 2 || decoded.userGroup == '2'){
                return(
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                            <h5 className="brandemiheader">Add products</h5>
                            </div>
                            <div className="row brandemitext">
                                Add the details of the products<br/>in the predefined format and<br/>upload it in the portal.
                            </div>
                        </div>
                    </div>
                )
            }
            else if(decoded.userGroup == 1 || decoded.userGroup == '1'){
                return(
                    <div className="row">
                        <div className="col-md-4">
                            <div className="row">
                            <h5 className="brandemiheader">1. Add products</h5>
                            </div>
                            <div className="row brandemitext">
                                Add the details of the products<br/>in the predefined format and<br/>upload it in the portal.
                            </div>
                        </div>
                        <div className="col-md-4 ">
                            <div className="row">
                                <h5 className="brandemiheader">2. Create bank schemes</h5>
                            </div>
                            <div className="row brandemitext">
                                Create bank schemes<br/> by choosing available options<br/> and name it as you want.
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row ">
                            <h5 className="brandemiheader">3. Create promotions</h5>
                            </div>
                            <div className="row brandemitext">
                                Build Promotion by providing details <br/>regarding how you would like <br/>the promotion to function.
                            </div>
                        </div>
                    </div>
                )
            }
        }

        return (
            <div className = "content">
                <CommonNavbar/>
                <div className="container-fluid">
                    <div className = "row">
                        {/* <div className="col-md-6 col-md-offset-3">
                            <div className="card p-10">
                                <div className="header text-center">
                                    <h2 className="title">
                                        <i className="fa fa-diamond" aria-hidden="true"></i>
                                        <br/>
                                        Welcome To Brand EMI
                                    </h2>
                                    {/* <p className="category">
                                        <strong> Innoviti’s Analytics Platform </strong>
                                    </p>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-md-12">
                            <div className="card p-10">
                                {header_data()}
                                {stepper_data()}
                                <div className="row">

                                </div>
                                {show_data()}
                            </div>
                        </div>

                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                    </div>
                </div>
            </div>
            </div>

        );

    }


}
export default BrandEMIAdmin;